export default {
  state: {
    data: {},
    order: [],
    loading: false,
    error: null,
    queue: [],
    config: {
      default: 'PRODUCT',
      append: '_NAV',
      path: 'product/nav',
      error: { active: false },
      get: { active: true, msg: '' },
      update: { active: false, msg: '' },
      create: { active: false, msg: '' },
      delete: { active: false, msg: '' },
    },
  },
  getters: {
    dataByParentId: (state) => (id) => {
      const { nav } = state.data[id] || { nav: [] };
      // const { nav } = state.data[id] || { nav: [] };
      return nav;
    },
  },
  mutations: {},
  methods: {
  },
  actions: {
    SOCKET_PRODUCT_NAV({ commit, dispatch, getters }, payload) {
      if (process.env.NODE_ENV !== 'production') console.log(`[${getters.config.path}] SOCKET_PRODUCT_NAV`, payload);

      function orderNavByPos(nav) {
        let orderedNav = [];

        nav.forEach((navItem) => {
          const navCopy = { ...navItem };
          navCopy.children = orderNavByPos(navCopy.children);
          orderedNav.push(navCopy);
        });

        orderedNav = orderedNav.sort((a, b) => a.pos - b.pos);
        return orderedNav;
      }

      // commit('PUSH_DATA', { ...payload[1], nav: orderNavByPos(payload[1].nav) });
      dispatch('HANDLE_PAYLOAD', { ...payload[1], nav: orderNavByPos(payload[1].nav) });

      commit('REMOVE_QUEUE', payload[0]);
      // commit('SET_LOADING', false);
    },
  },
};
